import { ComponentType } from 'react';
import { IconGallery } from '../icon/IconGallery';
import { IconVideo } from '../icon/IconVideo';
import type { PostUI } from './types';
import type { IconProps } from '../icon/createIconComponent';

export const getContentIcon = (
    content: PostUI['content'] = [],
): ComponentType<IconProps> | null => {
    const [firstSlide] = content;

    if (content.length > 1) {
        return IconGallery;
    }

    if (firstSlide && firstSlide?.type === 'video') {
        return IconVideo;
    }

    return null;
};
